import React from 'react'

import { Alert, Box, Text } from '@factorialco/deprecated-design-system'
import { PurchaseRequestFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import ApprovalsInformationBlock from 'modules/approvals/components/ApprovalsInformationBlock'
import ContactInfo from 'modules/finance/components/Contacts/ContactInfo'
import AdditionalInfo from 'modules/procurement/components/purchaseRequests/PurchaseRequestDetail/AdditionalInfo'
import GeneralInfo from 'modules/procurement/components/purchaseRequests/PurchaseRequestDetail/GeneralInfo'
import { PURCHASE_REQUEST_RESOURCE } from 'modules/procurement/components/purchaseRequests/PurchaseRequestDetail/constants'

interface Props {
  purchaseRequest: PurchaseRequestFragment
  renderApprovalsKey: number
}

const LegacyApprovalLayout = ({ purchaseRequest, renderApprovalsKey }: Props) => {
  return (
    <Box paddingTop="s24" gap="s24">
      {purchaseRequest.rejectionReason && <Alert>{purchaseRequest.rejectionReason}</Alert>}
      <GeneralInfo purchaseRequest={purchaseRequest} />
      <AdditionalInfo purchaseRequest={purchaseRequest} />
      {purchaseRequest.vendor && (
        <Box paddingTop="s24">
          <Text weight="semibold" size="200" color="grey700" caps>
            {i18n.t('finance.vendors.vendor_detail.title')}
          </Text>
          <ContactInfo contact={purchaseRequest.vendor} as={'vendor'} editable />
        </Box>
      )}
      <Box paddingTop="s24">
        <ApprovalsInformationBlock
          key={renderApprovalsKey}
          resourceId={purchaseRequest.id}
          resourceType={PURCHASE_REQUEST_RESOURCE}
        />
      </Box>
    </Box>
  )
}

export default LegacyApprovalLayout
